import SafeMarkdown from './SafeMarkdown';
import WidgetRenderer from './WidgetRenderer';
import { dailyStatsForComponent } from '../services/componentRunService';
import { Link } from 'react-router-dom';

function ComponentRenderer({ component, runs = [], stories = [], timelineEvents = [], widgets = [], username = '' }) {
  const settings = component.settings || {};
  const limit = Number(settings.limit) || 5;

  if (component.templateId === 'hero-bio') {
    return (
      <div className="component-renderer">
        {settings.tagline ? <p className="lead">{settings.tagline}</p> : null}
        <SafeMarkdown>{settings.bio}</SafeMarkdown>
      </div>
    );
  }

  if (component.templateId === 'custom-markdown') {
    return <SafeMarkdown>{settings.content || 'This component is still being written.'}</SafeMarkdown>;
  }

  if (component.templateId === 'daily-reflection') {
    return (
      <div className="component-renderer">
        <p>{settings.prompt || 'What mattered today?'}</p>
        {settings.streakGoal ? <p className="muted">Streak goal: {settings.streakGoal} days</p> : null}
      </div>
    );
  }

  if (component.templateId === 'habit-check-in') {
    return (
      <div className="component-renderer">
        <p><strong>{settings.habit || component.title}</strong></p>
        <p>{settings.question || 'Did you show up today?'}</p>
      </div>
    );
  }

  if (component.templateId === 'daily-stats') {
    const stats = settings.sourceComponentId ? dailyStatsForComponent(runs, settings.sourceComponentId) : null;

    return (
      <div className="component-renderer">
        {settings.title ? <h3>{settings.title}</h3> : null}
        {stats ? (
          <div className="stats-list compact-stats-list">
            <span>Day: {stats.day}</span>
            <span>Week: {stats.week}</span>
            <span>Month: {stats.month}</span>
            <span>Year: {stats.year}</span>
            <span>All time: {stats.allTime}</span>
          </div>
        ) : (
          <p className="muted">Connect this component to a daily to show stats.</p>
        )}
      </div>
    );
  }

  if (component.templateId === 'story-list') {
    return stories.length ? (
      <div className="embedded-list">
        {stories.slice(0, limit).map((story) => (
          <article key={story.id}>
            <h3><Link to={`/u/${username}/stories/${story.id}`}>{story.title}</Link></h3>
            <SafeMarkdown>{story.summary || story.content}</SafeMarkdown>
          </article>
        ))}
      </div>
    ) : <p className="muted">No visible stories yet.</p>;
  }

  if (component.templateId === 'timeline-list') {
    return timelineEvents.length ? (
      <div className="embedded-list timeline-mini">
        {timelineEvents.slice(0, limit).map((event) => (
          <article key={event.id}>
            <span>{event.dateLabel || event.sortYear || 'Undated'}</span>
            <h3>{event.title}</h3>
            <p>{event.description}</p>
          </article>
        ))}
      </div>
    ) : <p className="muted">No visible timeline events yet.</p>;
  }

  if (component.templateId === 'legacy-widgets') {
    return widgets.length ? (
      <div className="embedded-list widget-section-list">
        {widgets.map((widget) => (
          <article className="widget-profile-section" key={widget.id}>
            <WidgetRenderer widget={widget} />
          </article>
        ))}
      </div>
    ) : <p className="muted">No visible widgets yet.</p>;
  }

  return (
    <div className="component-renderer">
      {Object.entries(settings).map(([key, value]) => (
        <p key={key}><strong>{key}:</strong> {String(value)}</p>
      ))}
    </div>
  );
}

export default ComponentRenderer;
